/**
 * Роли системы для интерфейса: перечень и человекочитаемые названия.
 *
 * Flow: хедер подписывает пользователя названием роли → раздел «Настройки»
 *       строит из перечня выпадающий список при заведении и правке
 *       учётной записи.
 *
 * Зависимостей нет: это таблица названий, и ни React, ни клиент API ей
 * не нужны.
 *
 * ПОЧЕМУ ПЕРЕЧЕНЬ РОЛЕЙ ЗДЕСЬ, А СОСТАВ РАЗДЕЛОВ — С СЕРВЕРА. Разница не в
 * удобстве, а в том, КТО меняет значение. Состав разделов и их выдачу правит
 * администратор в работающей системе — второй список в коде разошёлся бы с
 * его решением молча (техспека BL-2026-10-08-a315 §2). Набор ролей закрыт и
 * живёт в коде вместе с предикатами операций: роль без предикатов — пустое
 * имя, и завести её из интерфейса нельзя (техспека BL-2026-10-08-5204 §8).
 * Изменить набор можно только выкладкой, которая несёт и этот файл.
 *
 * Связанные файлы:
 *   - src/App.jsx — подпись пользователя в хедере;
 *   - src/SettingsPanel.jsx — список роли при заведении и правке записи;
 *   - services/backend-api/internal/domain/user.go — RoleCodes, тот же
 *     набор и тот же порядок; расхождение видно по названию-коду на экране.
 */

/**
 * Коды ролей в порядке показа — он повторяет domain.RoleCodes.
 *
 * Порядок осмысленный, а не алфавитный: от полного доступа к read-only и
 * дальше к отдельному отделу. В выпадающем списке это читается как
 * «насколько широкий доступ выдаём».
 */
export const ROLE_CODES = [
  "admin",
  "treasurer",
  "backoffice",
  "viewer",
  "dealing",
];

/** Человекочитаемые названия ролей (context/project-brief.yaml). */
export const ROLE_TITLES = {
  admin: "Администратор",
  treasurer: "Казначей / финдиректор",
  backoffice: "Бэкофис",
  viewer: "Наблюдатель",
  // Роль заведена карточкой BL-2026-09-16-90e6, названия у неё здесь не
  // было — и в хедере вместо названия показывался код роли.
  dealing: "Отдел дилинга",
};

/**
 * Название роли по коду.
 *
 * @param {string} code — код роли из ответа сервера
 * @returns {string} название, а при неизвестном коде — сам код
 *
 * Код вместо названия — намеренно, а не заглушка «неизвестная роль»:
 * так на экране видно, что сервер знает роль, которой нет в этой таблице,
 * и видно ИМЕННО ЕЁ имя. Пустая строка или «—» скрыли бы расхождение.
 */
export function roleTitle(code) {
  return ROLE_TITLES[code] || code;
}
